import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HeaderComp } from "./TambahDaftarAset/HeaderComp";
import {
  InputFieldResponsive,
  SelectFieldResponsive,
} from "../component/Utils";
import DatePicker from "react-datepicker";
import { Label, Button, Form } from "reactstrap";
import { postDataAction } from "../config/redux/action";
import {
  PG_NAMA_ASET,
  PG_ALAMAT_ASET,
  PG_LUAS_TANAH,
  PG_LUAS_BANGUNAN,
  PG_STATUS_ASET,
  PG_KETERANGAN,
  PG_PERUSAHAAN_ID,
  PG_LONGITUDE,
  PG_LATITUDE,
  PG_CREATE_BY_ID,
  PG_APPROVED_BY_ID,
  PG_UPDATED_BY_ID,
  PG_REJECTED_BY_ID,
  PG_CREATE_AT,
  PG_APPROVED_AT,
  PG_UPDATED_AT,
  PG_REJECTED_AT,
  PG_KOORDINAT,
  PG_TANAH_BANGUNAN,
} from "../constants";
import { Loader, Button as ButtonS } from "semantic-ui-react";
import Axios from "axios";
import { axiosConfig } from "../utils/helper";
import LoadingTop from "../component/LoadingTop";
import { SelectPerusahaan } from "../component/Utils";
import { toast } from "react-toastify";

const ActionButton = () => {
  const batal = (e) => {
    e.preventDefault();
    window.history.back();
  };
  return (
    <div className="d-flex justify-content-end">
      <Button type="button" className="mr-3" onClick={(e) => batal(e)}>
        Batal
      </Button>
      <ButtonS type="submit" color="blue">
        Simpan
      </ButtonS>
    </div>
  );
};

export default () => {
  const dispatch = useDispatch();
  const [daftarAset, setDaftarAset] = React.useState();
  React.useEffect(() => {

  }, []);

  const handleChange = (event, type) => {
    const { name, value } = event.target;
    setDaftarAset({ ...daftarAset, [name]: value });
  };

  const handleChangeDate = (name, value, type) => {
    setDaftarAset({ ...daftarAset, [name]: value });
  };
  const value = useSelector((state) => state.main.perusahaanFilter);

  const submit = (e) => {
    e.preventDefault();
    if (value) {
      const param = {
        path: "daftar-aset",
        body: {
          ...daftarAset,
          perusahaan: {
            id: value
          }
        },
        title: "daftarAset",
      };
      dispatch(postDataAction(param)).then((response) => window.history.back());
    } else {
      toast.error("Perusahaan harus diisi");
    }
  };

  return (
    <>
      <HeaderComp title="Tambah Aset" />
      <LoadingTop />
      <Form onSubmit={submit}>
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container shadow-sm py-3 border-0">
                <div className=" d-flex align-items-center justify-content-md-end mb-md-0 mb-3">
                  <label className="mr-3">Perusahaan</label>
                  <SelectPerusahaan options={{ value: "all", text: "Semua" }} />
                </div>
                <hr />
                <div className="mb-3">
                  <InputFieldResponsive
                    label="Nama Aset "
                    inputType={{
                      disabled: false,
                      required: true,
                      name: "namaAset",
                    }}
                    onChange={(e) => handleChange(e, PG_NAMA_ASET)}
                  />
                  <InputFieldResponsive
                    label="Alamat"
                    inputType={{
                      disabled: false,
                      required: true,
                      name: "alamat",
                    }}
                    onChange={(e) => handleChange(e, PG_ALAMAT_ASET)}
                  />
                  <InputFieldResponsive
                    label="Koordinat"
                    inputType={{
                      disabled: false,
                      required: false,
                      name: "koordinat",
                    }}
                    onChange={(e) => handleChange(e, PG_KOORDINAT)}
                  />
                  {/* <InputFieldResponsive
                    label="Latitude"
                    inputType={{
                      disabled: false,
                      required: false,
                      name: "latitude",
                    }}
                    onChange={(e) => handleChange(e, PG_LATITUDE)}
                  />
                  <InputFieldResponsive
                    label="Longitude"
                    inputType={{
                      disabled: false,
                      required: false,
                      name: "longitude",
                    }}
                    onChange={(e) => handleChange(e, PG_LONGITUDE)}
                  />*/}
                  <InputFieldResponsive
                    label="Luas Tanah"
                    inputType={{
                      disabled: false,
                      required: true,
                      name: "luasTanah",
                    }}
                    onChange={(e) => handleChange(e, PG_LUAS_TANAH)}
                  />
                  <InputFieldResponsive
                    label="Luas Bangunan"
                    inputType={{
                      disabled: false,
                      name: "luasBangunan",
                    }}
                    onChange={(e) => handleChange(e, PG_LUAS_BANGUNAN)}
                  />
                  <InputFieldResponsive
                    label="Tanah atau Bangunan"
                    inputType={{
                      disabled: false,
                      name: "tanahBangunan",
                    }}
                    onChange={(e) => handleChange(e, PG_TANAH_BANGUNAN)}
                  />

                  <InputFieldResponsive
                    label="Status Aset"
                    inputType={{
                      disabled: false,
                      name: "statusAset",
                    }}
                    onChange={(e) => handleChange(e, PG_STATUS_ASET)}
                  />
                  <InputFieldResponsive
                    label="Keterangan"
                    inputType={{
                      disabled: false,
                      name: "keterangan",
                    }}
                    onChange={(e) => handleChange(e, PG_KETERANGAN)}
                  />

                </div>
                <hr />
                <ActionButton />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};
